
export const __DEV__ = process.env.NODE_ENV !== 'production'

export default {
    reduxLogging: __DEV__,
    useReactotron: __DEV__
}
